import axios from 'axios';

const api = axios.create({
  baseURL: 'https://resqplus-backend-production-89f4.up.railway.app/api',
  timeout: 10000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;